<div class="po-wrapper">


    <po-menu *ngIf="profile?.title && profile?.title != '' " [p-logo]="logo" p-logo-alt="TOTVS MODA - Coletor" [p-automatic-toggle]="true"
        [p-collapsed]="false" [p-menus]="menus">
    </po-menu>

    <po-toolbar *ngIf="profile?.title" [p-profile]="profile" [p-profile-actions]="profileActions"
        p-title="TOTVS Moda - Coletor"></po-toolbar>

    <app-modal-terminal-select #modalTerminal (selected)="reloadAfterChange($event)"></app-modal-terminal-select>

    <app-modal-branch-select #modalBranch (selected)="reloadAfterChange($event)" *ngIf="profile?.title"></app-modal-branch-select>
    

    <router-outlet></router-outlet>

</div>